module.exports = __webpack_public_path__ + "img/carousel-vet-11.4f4bcd8b.jpg";